const TERMINALS = ['ITS', 'APM', 'LBCT', 'TTI'];
const SSLS = ['HMM', 'ONE', 'MSC', 'CMA'];
const CITIES = ['Long Beach', 'Los Angeles', 'Oakland', 'Seattle'];

const HEADER_HINT =
  'Target = delivery time + unloading time + drive to port';

function buildLiveUnloadPlannerCard(index) {
  const i = index + 1;
  const term = TERMINALS[index % TERMINALS.length];
  const ssl = SSLS[index % SSLS.length];
  const city = CITIES[index % CITIES.length];
  const dist = index === 0 ? 19 : 12 + (index % 8);
  const phase = index % 5;
  const shift = phase * 0.02;

  const customerLabel = index === 0 ? 'Customer A' : `Customer ${i}`;
  const containerNo =
    index === 0 ? 'HMMU4971909' : `MSKU${7000000 + i}`;

  return {
    id: `lu-${String(i).padStart(2, '0')}`,
    distanceMiles: dist,
    searchContainers: [containerNo],
    status: index % 3 === 0 ? 'Booked' : index % 3 === 1 ? 'Pending' : 'Open',
    badges: [`LU-${1000 + i}`, term, containerNo],
    headerHint: HEADER_HINT,
    containerInfo: [
      { label: 'Customer', value: customerLabel },
      { label: 'Warehouse', value: `Warehouse ${(index % 4) + 1}` },
      { label: 'City', value: city },
      { label: 'Container', value: containerNo },
      { label: 'Size / Type', value: '40HC' },
      { label: 'SSL', value: ssl },
    ],
    milestones: [
      { label: 'Delivery', value: 'Apr 6, 8:00 AM' },
      {
        label: 'Unload Done',
        value: 'Apr 6, 10:00 AM (2 hr)',
      },
      { label: 'Target Return', value: 'Apr 6, 11:30 AM' },
      { label: 'Window Start', value: 'Apr 6, 9:30 AM' },
      { label: 'Window End', value: 'Apr 6, 12:30 PM' },
      { label: 'Distance', value: `${dist} mi` },
    ],
    timeline: {
      windowStartLabel: 'Apr 6, 8:00 AM',
      windowEndLabel: 'Apr 6, 1:15 PM',
      nodes: [
        {
          id: 'n1',
          p: Math.min(0.95, 0.18 + shift),
          apiColor: '#F5C542',
          title: 'AutoBook Window Start',
          time: 'Apr 6, 9:30 AM',
        },
        {
          id: 'n2',
          p: Math.min(0.95, 0.38 + shift),
          apiColor: '#7DD3FC',
          title: 'Unload Done',
          time: 'Apr 6, 10:00 AM',
          extra: '2 hr',
        },
        {
          id: 'n3',
          p: Math.min(0.95, 0.52 + shift),
          apiColor: '#60A5FA',
          title: 'Appointment Booked',
          time: 'Apr 6, 11:00 AM',
        },
        {
          id: 'n4',
          p: Math.min(0.95, 0.62 + shift),
          apiColor: '#00ff33',
          title: 'Target Return',
          time: 'Apr 6, 11:30 AM',
        },
        {
          id: 'n5',
          p: Math.min(0.95, 0.82 + shift),
          apiColor: '#F5C542',
          title: 'AutoBook Window End',
          time: 'Apr 6, 12:30 PM',
        },
      ],
    },
    movementSegments: [
      { type: 'place', label: `Warehouse ${(index % 3) + 1}` },
      { type: 'leg', miles: dist },
      { type: 'place', label: 'Port Route' },
      { type: 'leg' },
      { type: 'place', label: term },
    ],
    createdAtIso: '2026-04-16T10:35:00.000Z',
    updatedAtIso: '2026-04-16T12:40:00.000Z',
  };
}

const liveUnloadPlannerTestData = Array.from({ length: 35 }, (_, k) =>
  buildLiveUnloadPlannerCard(k)
);

export default liveUnloadPlannerTestData;
